<app-breadcrumb></app-breadcrumb>
<div class="card mb-0">
    <div class="card-body">
        <dtg-analytics-drive-danger-stop-high-rpm-list [listType]="DtgListType.list"></dtg-analytics-drive-danger-stop-high-rpm-list>
    </div>
</div>